export type RatingMode = 'general' | 'beta-screen';

export type RatingFieldKey =
    'degerlendirme_sebebi'
    | 'memnuniyet_puani'
    | 'product_id'
    | 'tavsiye_metni'
    | 'tavsiye_puani'
    | 'anket_id';

export interface RatingQuestionConfig {
    key: RatingFieldKey;
    title: string | null;
    helper_text: string | null;
    max_score: number;
    low_score_threshold: number;
    score_hint?: string | null;
    reason_key: RatingFieldKey;
    reason_required: boolean;
    reason_label: string;
    reason_placeholder: string;
}

export interface RatingExtraFieldConfig {
    key: RatingFieldKey;
    type: string;
    label: string;
    optional_label?: string;
    placeholder: string;
    required: boolean;
}

export interface RatingLinkedinConfig {
    show_linkedin?: boolean;
    linkedin_title?: string;
    linkedin_url?: string;
    linkedin_label?: string;
}

export type RatingExtraFieldsConfig = RatingExtraFieldConfig[] | RatingLinkedinConfig;

export interface RatingSurveyConfig {
    id?: number;
    mode: RatingMode;
    product_id: number;
    title: string;
    description: string | null;
    remind_later_text: string;
    submit_text: string;
    active: number;
    sort_order?: number;
    questions: RatingQuestionConfig[];
    extra_fields: RatingExtraFieldsConfig;
}

export class RatingEntity {
    degerlendirme_sebebi: string | null = null;
    memnuniyet_puani: string | number | null = null;
    product_id: string | number | null = null;
    tavsiye_metni: string | null = null;
    tavsiye_puani: string | number | null = null;
    anket_id: number | null = null;
    // Anketi dolduran alt kullanicinin bagli oldugu ana hesap/buro bilgisi.
    // Kullanici girmez; saveRating sirasinda store'daki cache'li user'dan doldurulur.
    buro_adi: string | null = null;
    ana_hesap_sahibi: string | null = null;
    tenant_id: string | null = null;
    lisans_no: string | null = null;
}